const numbersRegexp = /[\d\s]+/g;
const numbersWithDecimalPointRegexp = /[\d\s]+([.,][\d\s]*$)?/g;
export const extractNumberWithWhitespace = (value, { allowDecimalPoint = true } = {}) => {
    const regexp = allowDecimalPoint
        ? numbersWithDecimalPointRegexp
        : numbersRegexp;
    const matching = value.match(regexp);
    if (matching) {
        return matching.join('');
    }
    return null;
};
